var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11H13.25V13H5.25V16L0.25 12L5.25 8V11ZM4.25 18H6.958C8.11269 19.0183 9.53669 19.6819 11.0591 19.9109C12.5816 20.14 14.1378 19.9249 15.541 19.2915C16.9442 18.6581 18.1349 17.6332 18.9701 16.3398C19.8053 15.0465 20.2495 13.5396 20.2495 12C20.2495 10.4604 19.8053 8.95354 18.9701 7.66019C18.1349 6.36683 16.9442 5.34194 15.541 4.7085C14.1378 4.07506 12.5816 3.85998 11.0591 4.08906C9.53669 4.31815 8.11269 4.98167 6.958 6H4.25C5.18066 4.75718 6.38833 3.74851 7.77707 3.05414C9.16581 2.35978 10.6973 1.99884 12.25 2C17.773 2 22.25 6.477 22.25 12C22.25 17.523 17.773 22 12.25 22C10.6973 22.0012 9.16581 21.6402 7.77707 20.9459C6.38833 20.2515 5.18066 19.2428 4.25 18Z",
    fill: "#727292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.15ebb7a5ae55acdf6e34773c36ae76b4.svg";
export { ForwardRef as ReactComponent };